export default "__VITE_ASSET__CnSiagPk__"